import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchPost } from "../../features/post/postSlice";
import Goback from "../Goback";
import Post from "./Post";
import RelatedPosts from "./RelatedPosts";

const Posts = () => {
  const { postId } = useParams();
  const { post, isLoading, isError, error } = useSelector(
    (state) => state.post
  ) 

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPost(postId));
  }, [dispatch, postId]);

  // decide what to show based on post state
  let content = null;
  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (post && !isError && !isLoading) {
    content = <Post post={post} />;
  } else if (isError && !isLoading && error) {
    content = <p>Post not found</p>;
  }

  return (
    <>
      <Goback />
      <section className="post-page-container">
        {/* <!-- detailed post  --> */}
        {content}
        {/* <!-- detailed post ends --> */}
        {/* <!-- related posts --> */}
        <RelatedPosts postId={postId} />
        {/* <!-- related posts ends --> */}
      </section>
    </>
  );
};

export default Posts;
